module.exports = __webpack_public_path__ + "static/media/my-privacy-settings.66280529.svg";